/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-09-19 14:21:34
 * @Description: Description
 */
'use strict';

angular.module('dropdownModule', [])
.directive('dropdownList', function() {
    return{
        scope: {},
        restrict:'AE',
        templateUrl:'./resourceCenter/directive/dropDown/dropdown.html',
        replace: true,
        link:function($scope, iElm, iAttrs, controller){
            initStatus();
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {
                    screenWrapSelected:false
                }
            }
            /*
            展开收缩
             */
            $scope.toggleShow = function(){
                $scope.status.screenWrapSelected = !$scope.status.screenWrapSelected;
            }
        }
    }
});
